/* projects/speaker-platform/src/app/pages/email-validation-releve/email-validation-releve.component.scss */
h1 {
  font-family: "roboto", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 32px;
  margin: 60px 0;
}
h2 {
  font-family: "roboto", sans-serif;
  font-weight: 700;
  font-style: normal;
  font-size: 22px;
}
.error-feedback {
  color: #952626;
  font-size: 14px;
}
.validate {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  height: 100%;
}
.validate__content {
  grid-area: 1/1/2/2;
  height: 100%;
  background-color: #fff;
  position: relative;
}
.validate__loader {
  display: none;
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 9;
  transform: translateY(-50%) translateX(-50%) scale(3);
}
.validate__loader--is-loading {
  display: block;
}
.validate__contentwrapper {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translateY(-50%) translateX(-50%);
  width: 82%;
}
.validate__contentwrapper--is-loading {
  filter: blur(5px);
}
.validate__logo {
  margin: 32px 0 0 32px;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}
.validate__logo h1 {
  margin-right: 30px;
  margin-bottom: 0;
  margin-top: 0;
}
.validate__form {
  margin: 0 auto;
}
.validate__footer {
  position: absolute;
  bottom: 15px;
  left: 15px;
  font-size: 12px;
}
.validate__illustration {
  grid-area: 1/2/2/4;
  background-image: url("./media/login-background-6B3YCR6M.jpg");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
}
/*# sourceMappingURL=email-validation-releve.component-UQQRMS22.css.map */
